import React from 'react'

export default function Weather() {
  return (
    <div>
      Weather
    </div>
  )
}
